module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-branch-office/master-branch-office.component.scss
// module id = ./src/app/master/master-branch-office/master-branch-office.component.scss
// module chunks = main